import * as MT from "./mutationTypes";
export default {
  //*************************SB MAIN *******************************//
  [MT.SET_SBMAIN]: (state, response) => {
    return (state.sbMain = { ...response.sbMain });
  },
  [MT.SET_SBMAIN_BLANK]: state => {
    Object.keys(state.sbMain).forEach(function(index) {
      state.sbMain[index] = null;
    });
    return;
  },
  [MT.SET_SBMAIN_NAME]: (state, response) => {
    return (state.sbMain.jobName = response.value);
  },
  [MT.SET_SBMAIN_DATE]: (state, response) => {
    return (state.sbMain.jobDate = response.value);
  },
  [MT.SET_SBMAIN_PORT_LOCATION]: (state, response) => {
    return (state.sbMain.portLocation = response.value);
  },
  [MT.SET_SBMAIN_CHA]: (state, response) => {
    return (state.sbMain.chaLicenseNo = response.value);
  },
  [MT.SET_SBMAIN_TRANSPORT_MODE]: (state, response) => {
    return (state.sbMain.transportMode = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_IEC]: (state, response) => {
    return (state.sbMain.iec = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_IEC]: (state, response) => {
    return (state.sbMain.iec = response.value);
  },
  [MT.SET_SCHEME_ABBREVIATION]: (state, response) => {
    state.schemeAbbreviations.splice(0, state.schemeAbbreviations.length);
    const schemes = response.scheme.split(",");
    let schemeAbbreviation = { ...response };
    schemes.forEach(scheme => {
      schemeAbbreviation.scheme = scheme;
      state.schemeAbbreviations.push({ ...schemeAbbreviation });
    });
    return;
  },
  [MT.SET_SBMAIN_EXPORTER_BRANCH]: (state, response) => {
    return (state.sbMain.exporterBranch = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_NAME]: (state, response) => {
    return (state.sbMain.exporterName = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_ADDRESS1]: (state, response) => {
    return (state.sbMain.exporterAddress1 = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_ADDRESS2]: (state, response) => {
    return (state.sbMain.exporterAddress2 = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_CITY]: (state, response) => {
    return (state.sbMain.exporterCity = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_STATE]: (state, response) => {
    return (state.sbMain.exporterState = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_PIN]: (state, response) => {
    return (state.sbMain.exporterPin = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_CLASS]: (state, response) => {
    return (state.sbMain.exporterClass = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_STATE_CODE_OF_ORIGIN_EXPORTER]: (state, response) => {
    return (state.sbMain.stateCodeOfOriginExporter = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_STATE_CODE_OF_ORIGIN_EXPORTER_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.stateCodeOfOriginExporterDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_AD_CODE]: (state, response) => {
    return (state.sbMain.exporterAdCode = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_BANK_NAME]: (state, response) => {
    return (state.sbMain.exporterBankName = response.value);
  },
  [MT.SET_SBMAIN_EXPORTER_EPZ_CODE]: (state, response) => {
    return (state.sbMain.epzCode = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_NAME]: (state, response) => {
    return (state.sbMain.consigneeName = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_ADDRESS1]: (state, response) => {
    return (state.sbMain.consigneeAddress1 = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_ADDRESS2]: (state, response) => {
    return (state.sbMain.consigneeAddress2 = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_ADDRESS3]: (state, response) => {
    return (state.sbMain.consigneeAddress3 = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_ADDRESS4]: (state, response) => {
    return (state.sbMain.consigneeAddress4 = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_COUNTRY_CODE]: (state, response) => {
    return (state.sbMain.consigneeCountryCode = response.value);
  },
  [MT.SET_SBMAIN_CONSIGNEE_COUNTRY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.consigneeCountryCodeDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_NFEI_SB_CATEGORY]: (state, response) => {
    return (state.sbMain.nfeiSbCategory = response.value);
  },
  [MT.SET_SBMAIN_RBI_WAIVER_NO]: (state, response) => {
    return (state.sbMain.rbiWaiverNo = response.value);
  },
  [MT.SET_SBMAIN_RBI_WAIVER_DATE]: (state, response) => {
    return (state.sbMain.rbiWaiverDate = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_LOADING]: (state, response) => {
    return (state.sbMain.portCodeOfLoading = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_LOADING_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.portCodeOfLoadingDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_FINAL_DESTINATION]: (state, response) => {
    return (state.sbMain.portCodeOfDestination = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_FINAL_DESTINATION_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.portCodeOfDestinationDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_COUNTRY_CODE_OF_FINAL_DESTINATION]: (state, response) => {
    return (state.sbMain.countryCodeOfFinalDestination = response.value);
  },
  [MT.SET_SBMAIN_COUNTRY_CODE_OF_FINAL_DESTINATION_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.countryCodeOfFinalDestinationDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_COUNTRY_CODE_OF_DISCHARGE]: (state, response) => {
    return (state.sbMain.countryCodeOfDischarge = response.value);
  },
  [MT.SET_SBMAIN_COUNTRY_CODE_OF_DISCHARGE_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.countryCodeOfDischargeDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_DISCHARGE]: (state, response) => {
    return (state.sbMain.portCodeOfDischarge = response.value);
  },
  [MT.SET_SBMAIN_PORT_CODE_OF_DISCHARGE_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.portCodeOfDischargeDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_SEAL_TYPE]: (state, response) => {
    return (state.sbMain.sealType = response.value);
  },
  [MT.SET_SBMAIN_NATURE_OF_CARGO]: (state, response) => {
    return (state.sbMain.natureOfCargo = response.value);
  },
  [MT.SET_SBMAIN_GROSS_WEIGHT]: (state, response) => {
    return (state.sbMain.grossWeight = response.value);
  },
  [MT.SET_SBMAIN_NET_WEIGHT]: (state, response) => {
    return (state.sbMain.netWeight = response.value);
  },
  [MT.SET_SBMAIN_UNIT_OF_MEASUREMENT]: (state, response) => {
    return (state.sbMain.unitOfMeasurement = response.value);
  },
  [MT.SET_SBMAIN_UNIT_OF_MEASUREMENT_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.unitOfMeasurementDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_PACKING_UNIT]: (state, response) => {
    return (state.sbMain.packingUnit = response.value);
  },
  [MT.SET_SBMAIN_PACKING_UNIT_DROPDOWN_VALUE]: (state, response) => {
    return (state.sbMain.packingUnitDropdownValue = response.value);
  },
  [MT.SET_SBMAIN_TOTAL_NO_OF_PACKAGES]: (state, response) => {
    return (state.sbMain.totalNoOfPackages = response.value);
  },
  [MT.SET_SBMAIN_MARKS_AND_NOS]: (state, response) => {
    return (state.sbMain.marksAndNos = response.value);
  },
  [MT.SET_SBMAIN_NO_OF_LOOSE_PACKETS]: (state, response) => {
    return (state.sbMain.noOfLoosePackets = response.value);
  },
  [MT.SET_SBMAIN_NO_OF_CONTAINERS]: (state, response) => {
    return (state.sbMain.noOfContainers = response.value);
  },
  [MT.SET_SBMAIN_MAWB_NO]: (state, response) => {
    return (state.sbMain.mawbNo = response.value);
  },
  [MT.SET_SBMAIN_HAWB_NO]: (state, response) => {
    return (state.sbMain.hawbNo = response.value);
  },
  [MT.SET_SBMAIN_GSTN_TYPE]: (state, response) => {
    return (state.sbMain.gstnType = response.value);
  },
  [MT.SET_SBMAIN_GSTN_ID]: (state, response) => {
    return (state.sbMain.gstnId = response.value);
  },

  //******************************  EXCHANGE RATE *******************************/

  [MT.SET_EXCHANGE_RATE_IN_EXPORT_JOB]: (state, response) => {
    state.exportJob.exchangeRates.pop();
    return state.exportJob.exchangeRates.push(response);
  },
  [MT.SET_EXCHANGE_RATE_EXCHANGE_RATES]: (state, response) => {
    return (state.exchangeRate.exchangeRate = response.value);
  },
  [MT.SET_EXCHANGE_RATE_INVOICE_CURRENCY_CODE]: (state, response) => {
    return (state.exchangeRate.invoiceCurrencyCode = response.value);
  },
  [MT.SET_EXCHANGE_RATE_INVOICE_CURRENCY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.exchangeRate.invoiceCurrencyCodeDropdownValue = response.value);
  },
  [MT.SET_EXCHANGE_RATE_CURRENCY_NAME]: (state, response) => {
    return (state.exchangeRate.currencyName = response.value);
  },
  [MT.SET_EXCHANGE_RATE_UNIT_IN_RS]: (state, response) => {
    return (state.exchangeRate.unitInRs = response.value);
  },
  [MT.SET_EXCHANGE_RATE_RATE]: (state, response) => {
    return (state.exchangeRate.rate = response.value);
  },
  [MT.SET_EXCHANGE_RATE_EFFECTIVE_DATE]: (state, response) => {
    return (state.exchangeRate.effectiveDate = response.value);
  },
  [MT.SET_EXCHANGE_RATE_WHETHER_STANDARD_CURRENCY]: (state, response) => {
    return (state.exchangeRate.whetherStandardCurrency = response.value);
  },

  //*********************************  LICENCE  ********************************//

  [MT.REMOVE_LICENSE_FROM_EXPORT_JOB]: (state, license) => {
    const licenseIndex = state.exportJob.licenses.findIndex(
      licenseArray =>
        licenseArray.invoiceSrNo === license.invoiceSrNo &&
        licenseArray.itemSrNo === license.itemSrNo &&
        license.srNo === licenseArray.srNo &&
        license.schemeAbbreviation === licenseArray.schemeAbbreviation
    );
    if (licenseIndex >= 0) {
      state.exportJob.licenses.splice(licenseIndex, 1);
    }
    return;
  },
  [MT.SET_LICENSE_BLANK]: state => {
    Object.keys(state.license).forEach(function(index) {
      state.license[index] = null;
    });
    return;
  },
  [MT.SET_LICENSE_FROM_EXPORT_JOB]: (state, response) => {
    return (state.license = {
      ...response
    });
  },
  [MT.REASSIGN_SRNO_TO_LICENSES_IN_EXPORT_JOB]: (state, itemToBeRemoved) => {
    // decrementing itemSrNo for GREATER THAN removing element in licenses array
    console.log(state.exportJob.licenses, "state.exportJob.licenses");
    console.log(itemToBeRemoved, "removingSrNo");
    state.exportJob.licenses = state.exportJob.licenses.map(license => {
      if (
        parseInt(license.srNo) > parseInt(itemToBeRemoved.srNo) &&
        license.schemeAbbreviation === itemToBeRemoved.schemeAbbreviation &&
        license.invoiceSrNo === itemToBeRemoved.invoiceSrNo &&
        license.itemSrNo === itemToBeRemoved.itemSrNo
      ) {
        license.srNo = parseInt(license.srNo) - 1;
      }
      return license;
    });
    console.log(state.exportJob.licenses, "last state.exportJob.licenses");
  },
  [MT.SET_LICENSES_IN_EXPORT_JOB]: (state, license) => {
    const isLicense = state.exportJob.licenses.find(
      licenseArray =>
        licenseArray.schemeAbbreviation === license.schemeAbbreviation &&
        licenseArray.invoiceSrNo === license.invoiceSrNo &&
        licenseArray.itemSrNo === license.itemSrNo &&
        licenseArray.srNo === license.srNo
    );
    if (isLicense !== undefined) {
      Object.assign(isLicense, {
        ...license
      });
      return;
    } else {
      return state.exportJob.licenses.push(license);
    }
  },
  [MT.SET_LICENCE_INVOICE_SR_NO]: (state, response) => {
    return (state.license.invoiceSrNo = response.value);
  },
  [MT.SET_LICENCE_ITEM_SR_NO]: (state, response) => {
    return (state.license.itemSrNo = response.value);
  },
  [MT.SET_LICENCE_SR_NO]: (state, response) => {
    return (state.license.srNo = response.value);
  },
  [MT.SET_LICENCE_REGISTRATION_NO]: (state, response) => {
    return (state.license.registrationNo = response.value);
  },
  [MT.SET_LICENCE_REGISTRATION_DATE]: (state, response) => {
    return (state.license.registrationDate = response.value);
  },
  [MT.SET_LICENCE_SR_NO_IN_PART_E]: (state, response) => {
    return (state.license.itemSrNoInPart_E = response.value);
  },
  [MT.SET_LICENCE_SR_NO_IN_PART_C]: (state, response) => {
    return (state.license.itemSrNoInPart_C = response.value);
  },
  [MT.SET_LICENCE_QUANTITY]: (state, response) => {
    return (state.license.quantity = response.value);
  },
  [MT.SET_LICENCE_QUANTITY_DROPDOWN_VALUE]: (state, response) => {
    return (state.license.quantityDropdownValue = response.value);
  },
  [MT.SET_LICENCE_EXPORT_QUANTITY]: (state, response) => {
    return (state.license.exportQuantity = response.value);
  },
  [MT.SET_LICENCE_WHETHER_INDEGENOUS]: (state, response) => {
    return (state.license.whetherIndegenous = response.value);
  },
  [MT.SET_LICENCE_WHETHER_INDEGENOUS_DROPDOWN_VALUE]: (state, response) => {
    return (state.license.whetherIndegenousDropdownValue = response.value);
  },

  //******************************  INVOICE  ************************************//

  [MT.SET_INVOICES_BUYER_DETAILS]: (state, addressString) => {
    state.exportJob.invoices.map(invoice => {
      invoice.buyerName = addressString.substring(0, parseInt(addressString.length) / 2);
      invoice.buyerAddress1 = addressString.substring(parseInt(addressString.length) / 2, addressString.length);
      return invoice;
    });
    return;
  },
  [MT.SET_INVOICE_BLANK]: state => {
    Object.keys(state.invoice).forEach(function(index) {
      state.invoice[index] = null;
    });
    return;
  },
  [MT.SET_INVOICE_FROM_EXPORT_JOB]: (state, response) => {
    Object.assign(state.invoice, {
      ...response
    });
    return;
  },
  [MT.SET_INVOICE_INVOICE_SR_NO]: (state, response) => {
    return (state.invoice.invoiceSrNo = response.value);
  },
  [MT.SET_INVOICE_INVOICE_NAME]: (state, response) => {
    return (state.invoice.invoiceName = response.value);
  },
  [MT.SET_INVOICE_INVOICE_DATE]: (state, response) => {
    return (state.invoice.invoiceDate = response.value);
  },
  [MT.SET_INVOICE_EXCHANGE_RATE]: (state, response) => {
    return (state.invoice.exchangeRate = response.value);
  },
  [MT.SET_INVOICE_INVOICE_CURRENCY_CODE]: (state, response) => {
    return (state.invoice.invoiceCurrencyCode = response.value);
  },
  [MT.SET_INVOICE_INVOICE_CURRENCY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.invoiceCurrencyCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_NATURE_OF_CONTRACT]: (state, response) => {
    return (state.invoice.natureOfContract = response.value);
  },
  [MT.SET_INVOICE_NATURE_OF_CONTRACT_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.natureOfContractDropdownValue = response.value);
  },
  [MT.SET_INVOICE_INVOICE_VALUE]: (state, response) => {
    return (state.invoice.invoiceValue = response.value);
  },
  [MT.SET_INVOICE_BUYER_NAME]: (state, response) => {
    return (state.invoice.buyerName = response.value);
  },
  [MT.SET_INVOICE_BUYER_ADDRESS1]: (state, response) => {
    return (state.invoice.buyerAddress1 = response.value);
  },
  [MT.SET_INVOICE_BUYER_ADDRESS2]: (state, response) => {
    return (state.invoice.buyerAddress2 = response.value);
  },
  [MT.SET_INVOICE_BUYER_ADDRESS3]: (state, response) => {
    return (state.invoice.buyerAddress3 = response.value);
  },
  [MT.SET_INVOICE_BUYER_ADDRESS4]: (state, response) => {
    return (state.invoice.buyerAddress4 = response.value);
  },
  [MT.SET_INVOICE_FREIGHT_CURRENCY_CODE]: (state, response) => {
    return (state.invoice.freightCurrencyCode = response.value);
  },
  [MT.SET_INVOICE_FREIGHT_CURRENCY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.freightCurrencyCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_FREIGHT_AMOUNT]: (state, response) => {
    return (state.invoice.freightAmount = response.value);
  },
  [MT.SET_INVOICE_INSURANCE_RATE]: (state, response) => {
    return (state.invoice.insuranceRate = response.value);
  },
  [MT.SET_INVOICE_INSURANCE_CURRENCY_CODE]: (state, response) => {
    return (state.invoice.insuranceCurrencyCode = response.value);
  },
  [MT.SET_INVOICE_INSURANCE_CURRENCY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.insuranceCurrencyCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_INSURANCE_AMOUNT]: (state, response) => {
    return (state.invoice.insuranceAmount = response.value);
  },
  [MT.SET_INVOICE_COMMISSION_RATE]: (state, response) => {
    return (state.invoice.commissionRate = response.value);
  },
  [MT.SET_INVOICE_COMMISSION_CURRENCY_CODE]: (state, response) => {
    return (state.invoice.commissionCurrencyCode = response.value);
  },
  [MT.SET_INVOICE_COMMISSION_CURRENCY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.commissionCurrencyCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_COMMISSION_AMOUNT]: (state, response) => {
    return (state.invoice.commissionAmount = response.value);
  },
  [MT.SET_INVOICE_DISCOUNT_IN_FOB_PERCENTAGE]: (state, response) => {
    return (state.invoice.discountInFOBPercentage = response.value);
  },
  [MT.SET_INVOICE_DISCOUNT_CURRENCY]: (state, response) => {
    return (state.invoice.discountCurrency = response.value);
  },
  [MT.SET_INVOICE_DISCOUNT_CURRENCY_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.discountCurrencyDropdownValue = response.value);
  },
  [MT.SET_INVOICE_DISCOUNT_AMOUNT]: (state, response) => {
    return (state.invoice.discountAmount = response.value);
  },
  [MT.SET_INVOICE_OTHER_DEDUCTIONS_PERCENTAGE]: (state, response) => {
    return (state.invoice.otherDeductionsPercentage = response.value);
  },
  [MT.SET_INVOICE_OTHER_DEDUCTIONS_CURRENCY]: (state, response) => {
    return (state.invoice.otherDeductionsCurrency = response.value);
  },
  [MT.SET_INVOICE_OTHER_DEDUCTIONS_CURRENCY_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.otherDeductionsCurrencyDropdownValue = response.value);
  },
  [MT.SET_INVOICE_OTHER_DEDUCTIONS_AMOUNT]: (state, response) => {
    return (state.invoice.otherDeductionsAmount = response.value);
  },
  [MT.SET_INVOICE_UNIT_PRICE_INCLUDES]: (state, response) => {
    return (state.invoice.unitPriceIncludes = response.value);
  },
  [MT.SET_INVOICE_ADD_PACKING_CHARGES]: (state, response) => {
    return (state.invoice.packagingCharges = response.value);
  },
  [MT.SET_INVOICE_EXPORTER_CONTRACT_NO]: (state, response) => {
    return (state.invoice.exporterContractNo = response.value);
  },
  [MT.SET_INVOICE_NATURE_OF_PAYMENT]: (state, response) => {
    return (state.invoice.natureOfPayment = response.value);
  },
  [MT.SET_INVOICE_PERIOD_OF_PAYMENT_IN_DAYS]: (state, response) => {
    return (state.invoice.periodOfPaymentInDays = response.value);
  },
  [MT.SET_INVOICE_IS_THIRD_PARTY]: (state, response) => {
    return (state.invoice.isThirdParty = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_IEC]: (state, response) => {
    return (state.invoice.thirdPartyIec = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_NAME]: (state, response) => {
    return (state.invoice.thirdPartyName = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_ADDRESS1]: (state, response) => {
    return (state.invoice.thirdPartyAddress1 = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_ADDRESS2]: (state, response) => {
    return (state.invoice.thirdPartyAddress2 = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_CITY]: (state, response) => {
    return (state.invoice.thirdPartyCity = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_COUNTRY_SUB_DIVISION]: (state, response) => {
    return (state.invoice.thirdPartyCountrySubdivision = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_COUNTRY_CODE]: (state, response) => {
    return (state.invoice.thirdPartyCountryCode = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_COUNTRY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.thirdPartyCountryCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_THIRD_PARTY_PIN]: (state, response) => {
    return (state.invoice.thirdPartyPin = response.value);
  },
  [MT.SET_INVOICE_AUTHORIZED_ECONOMIC_OPERATOR_CODE]: (state, response) => {
    return (state.invoice.authorizedEconomicOperatorCode = response.value);
  },
  [MT.SET_INVOICE_AUTHORIZED_ECONOMIC_OPERATOR_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.invoice.authorizedEconomicOperatorCodeDropdownValue = response.value);
  },
  [MT.SET_INVOICE_AUTHORIZED_ECONOMIC_OPERATOR_COUNTRY_CODE]: (state, response) => {
    return (state.invoice.authorizedEconomicOperatorCountryCode = response.value);
  },
  [MT.SET_INVOICE_AUTHORIZED_ECONOMIC_OPERATOR_ROLE]: (state, response) => {
    return (state.invoice.authorizedEconomicOperatorRole = response.value);
  },
  [MT.SET_INVOICE_TERMS_PLACE]: (state, response) => {
    return (state.invoice.termsPlace = response.value);
  },
  [MT.SET_INVOICE_AMENDMENT_TYPE]: (state, response) => {
    return (state.invoice.amendmentType = response.value);
  },
  [MT.SET_INVOICE_AMENDMENT_NO]: (state, response) => {
    return (state.invoice.amendmentNo = response.value);
  },
  [MT.SET_INVOICE_AMENDMENT_DATE]: (state, response) => {
    return (state.invoice.amendmentDate = response.value);
  },

  //***********************************  DRAWBACK  ***********************************//
  [MT.SET_DRAWBACK_FROM_EXPORT_JOB]: (state, response) => {
    return (state.drawback = {
      ...response
    });
  },
  [MT.SET_DRAWBACK_BLANK]: state => {
    Object.keys(state.drawback).forEach(function(index) {
      state.drawback[index] = null;
    });
    return;
  },
  [MT.SET_DRAWBACK_IN_EXPORT_JOB]: (state, drawback) => {
    // if drawback exists
    const isDbk = state.exportJob.dbks.find(
      dbk => dbk.invoiceSrNo === drawback.invoiceSrNo && dbk.itemSrNo === drawback.itemSrNo
    );
    if (isDbk !== undefined) {
      Object.assign(isDbk, {
        ...drawback
      });
      return;
    } else {
      return state.exportJob.dbks.push(drawback);
    }
  },
  [MT.SET_DRAWBACK_INVOICE_SR_NO]: (state, response) => {
    return (state.drawback.invoiceSrNo = response.value);
  },
  [MT.SET_DRAWBACK_ITEM_SR_NO]: (state, response) => {
    return (state.drawback.itemSrNo = response.value);
  },
  [MT.SET_DRAWBACK_DBK_SCHEDULE_DROPDOWN_VALUE]: (state, response) => {
    return (state.drawback.dbkScheduleDropdownValue = response.value);
  },
  [MT.SET_DRAWBACK_DBK_SCHEDULE_NO]: (state, response) => {
    return (state.drawback.dbkScheduleNo = response.value);
  },
  [MT.SET_DRAWBACK_DBK_QUANTITY]: (state, response) => {
    return (state.drawback.dbkQuantity = response.value);
  },
  [MT.SET_DRAWBACK_DBK_RATE]: (state, response) => {
    return (state.drawback.dbkRate = response.value);
  },
  [MT.SET_DRAWBACK_DBK_AMOUNT]: (state, response) => {
    return (state.drawback.dbkAmount = response.value);
  },
  [MT.SET_DRAWBACK_AMENDMENT_TYPE]: (state, response) => {
    return (state.drawback.amendmentType = response.value);
  },
  [MT.SET_DRAWBACK_AMENDMENT_NO]: (state, response) => {
    return (state.drawback.amendmentNo = response.value);
  },
  [MT.SET_DRAWBACK_AMENDMENT_DATE]: (state, response) => {
    return (state.drawback.amendmentDate = response.value);
  },

  //*************************************  AR4  **************************************//

  [MT.SET_AR4_FROM_EXPORT_JOB]: (state, response) => {
    // return (state.ar4 = {
    //   ...response
    // });

    var srNo = response.srNo;
    if (srNo > state.exportJob.ar4s.length) {
      return state.exportJob.ar4s.push(response.ar4);
    } else if (srNo > 0) {
      srNo = srNo - 1;
      const ar4 = state.exportJob.ar4s[srNo];
      Object.assign(ar4, {
        ...response.ar4
      });
      return;
    }
  },
  [MT.REMOVE_AR4_FROM_EXPORT_JOB]: (state, response) => {
    const srNo = response.srNo;
    const ar4NoIndex = state.exportJob.ar4s.findIndex(ar4 => ar4.srNo === srNo);
    if (ar4NoIndex >= 0) {
      state.exportJob.ar4s.splice(ar4NoIndex, 1);
    }
    return;
  },
  [MT.REASSIGN_SRNO_TO_AR4S_IN_EXPORT_JOB]: (state, removingSrNo) => {
    // decrementing itemSrNo for GREATER THAN removing element in licenses array
    state.exportJob.ar4s = state.exportJob.ar4s.map(ar4 => {
      if (parseInt(ar4.srNo) > parseInt(removingSrNo)) {
        ar4.srNo = parseInt(ar4.srNo) - 1;
      }
      return ar4;
    });
  },
  [MT.SET_AR4_IN_EXPORT_JOB]: (state, response) => {
    var ar4SrNo = response.srNo;
    // if ar4 exists
    const isAr4 = state.exportJob.ar4s.find(ar4 => ar4.srNo === ar4SrNo);
    if (isAr4 !== undefined) {
      Object.assign(isAr4, {
        ...response.ar4
      });
      return;
    } else {
      return state.exportJob.ar4s.push(response.ar4);
    }
  },
  [MT.SET_AR4_INVOICE_SR_NO]: (state, response) => {
    return (state.ar4.invoiceSrNo = response.value);
  },
  [MT.SET_AR4_ITEM_SR_NO]: (state, response) => {
    return (state.ar4.itemSrNo = response.value);
  },
  [MT.SET_AR4_AR4_NO]: (state, response) => {
    return (state.ar4.ar4No = response.value);
  },
  [MT.SET_AR4_AR4_DATE]: (state, response) => {
    return (state.ar4.ar4Date = response.value);
  },
  [MT.SET_AR4_COMMISSIONERATE]: (state, response) => {
    return (state.ar4.commissionerate = response.value);
  },
  [MT.SET_AR4_DIVISION]: (state, response) => {
    return (state.ar4.division = response.value);
  },
  [MT.SET_AR4_RANGE]: (state, response) => {
    return (state.ar4.range = response.value);
  },
  [MT.SET_AR4_REMARKS]: (state, response) => {
    return (state.ar4.remarks = response.value);
  },

  //*************************************  CESS **************************************//
  [MT.SET_CESS_INVOICE_SR_NO]: (state, response) => {
    return (state.cess.invoiceSrNo = response.value);
  },
  [MT.SET_CESS_ITEM_SR_NO]: (state, response) => {
    return (state.cess.itemSrNo = response.value);
  },
  [MT.SET_CESS_SR_NO]: (state, response) => {
    return (state.cess.srNo = response.value);
  },
  [MT.SET_CESS_CESS_ACT_CODE]: (state, response) => {
    return (state.cess.cessActCode = response.value);
  },
  [MT.SET_CESS_CESS_ACT_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.cess.cessActCodeDropdownValue = response.value);
  },
  [MT.SET_CESS_QUANTITY]: (state, response) => {
    return (state.cess.quantity = response.value);
  },
  [MT.SET_CESS_AMENDMENT_TYPE]: (state, response) => {
    return (state.cess.amendmentType = response.value);
  },
  [MT.SET_CESS_AMENDMENT_NO]: (state, response) => {
    return (state.cess.amendmentNo = response.value);
  },
  [MT.SET_CESS_AMENDMENT_DATE]: (state, response) => {
    return (state.cess.amendmentDate = response.value);
  },

  //*************************************  CONTAINER  ********************************//

  [MT.SET_CONTAINER_IN_EXPORT_JOB]: (state, response) => {
    var srNo = response.srNo;
    if (srNo > state.exportJob.containers.length) {
      return state.exportJob.containers.push(response.container);
    } else if (srNo > 0) {
      srNo = srNo - 1;
      const container = state.exportJob.containers[srNo];
      Object.assign(container, {
        ...response.container
      });
      return;
    }
  },
  [MT.REMOVE_CONTAINER_FROM_EXPORT_JOB]: (state, response) => {
    const srNo = response.srNo;
    if (srNo >= 0) {
      state.exportJob.containers.splice(parseInt(srNo) - 1, 1);
    }
    return;
  },
  [MT.SET_CONTAINER_FROM_EXPORT_JOB]: (state, response) => {
    const srNo = response.srNo;
    const container = state.exportJob.containers.find(container => container.srNo === srNo);
    return (state.container = {
      ...container
    });
  },
  [MT.REASSIGN_SRNO_TO_CONTAINER_EXPORT_JOB]: (state, removingItemSrNo) => {
    // decrementing itemSrNo for GREATER THAN removing element in containers array
    state.exportJob.containers = state.exportJob.containers.map(container => {
      if (parseInt(container.srNo) > parseInt(removingItemSrNo)) {
        container.srNo = parseInt(container.srNo) - 1;
      }
      return container;
    });
  },
  [MT.SET_CONTAINER_SR_NO]: (state, response) => {
    return (state.container.srNo = response.value);
  },
  [MT.SET_CONTAINER_CONTAINER_NO]: (state, response) => {
    return (state.container.containerNo = response.value);
  },
  [MT.SET_CONTAINER_CONTAINER_SIZE]: (state, response) => {
    return (state.container.containerSize = response.value);
  },
  [MT.SET_CONTAINER_EXCISE_SEAL_NO]: (state, response) => {
    return (state.container.exciseSealNo = response.value);
  },
  [MT.SET_CONTAINER_SEAL_DATE]: (state, response) => {
    return (state.container.sealDate = response.value);
  },
  [MT.SET_CONTAINER_SEAL_TYPE_INDICATOR]: (state, response) => {
    return (state.container.sealTypeIndicator = response.value);
  },
  [MT.SET_CONTAINER_SEAL_DEVICE_ID]: (state, response) => {
    return (state.container.sealDeviceId = response.value);
  },
  [MT.SET_CONTAINER_MOVEMENT_DOCUMENT_TYPE]: (state, response) => {
    return (state.container.movementDocumentType = response.value);
  },
  [MT.SET_CONTAINER_MOVEMENT_DOCUMENT_NO]: (state, response) => {
    return (state.container.movementDocumentNo = response.value);
  },
  //*************************************  DEPB  *************************************//
  [MT.SET_DEPB_BLANK]: state => {
    Object.keys(state.depb).forEach(function(index) {
      state.depb[index] = null;
    });
    return;
  },
  [MT.SET_DEPB_INVOICE_SR_NO]: (state, response) => {
    return (state.depb.invoiceSrNo = response.value);
  },
  [MT.SET_DEPB_ITEM_SR_NO]: (state, response) => {
    return (state.depb.itemSrNo = response.value);
  },
  [MT.SET_DEPB_GROUP_CODE]: (state, response) => {
    return (state.depb.groupCode = response.value);
  },
  [MT.SET_DEPB_GROUP_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.depb.groupCodeDropdownValue = response.value);
  },
  [MT.SET_DEPB_ITEM_CODE]: (state, response) => {
    return (state.depb.itemCode = response.value);
  },
  [MT.SET_DEPB_QUANTITY]: (state, response) => {
    return (state.depb.quantity = response.value);
  },
  [MT.SET_DEPB_AMENDMENT_TYPE]: (state, response) => {
    return (state.depb.amendmentType = response.value);
  },
  [MT.SET_DEPB_AMENDMENT_NO]: (state, response) => {
    return (state.depb.amendmentNo = response.value);
  },
  [MT.SET_DEPB_AMENDMENT_DATE]: (state, response) => {
    return (state.depb.amendmentDate = response.value);
  },

  //************************************  DEPB PARENT ********************************//
  [MT.SET_DEPB_PARENT_INVOICE_SR_NO]: (state, response) => {
    return (state.depbParent.invoiceSrNo = response.value);
  },
  [MT.SET_DEPB_PARENT_ITEM_SR_NO]: (state, response) => {
    return (state.depbParent.itemSrNo = response.value);
  },
  [MT.SET_DEPB_PARENT_SR_NO]: (state, response) => {
    return (state.depbParent.srNo = response.value);
  },
  [MT.SET_DEPB_PARENT_GROUP_CODE]: (state, response) => {
    return (state.depbParent.groupCode = response.value);
  },
  [MT.SET_DEPB_PARENT_ITEM_CODE]: (state, response) => {
    return (state.depbParent.itemCode = response.value);
  },
  [MT.SET_DEPB_PARENT_QUANTITY]: (state, response) => {
    return (state.depbParent.quantity = response.value);
  },
  [MT.SET_DEPB_PARENT_UNIT_QUANTITY_CODE]: (state, response) => {
    return (state.depbParent.unitQuantityCode = response.value);
  },
  [MT.SET_DEPB_PARENT_QUANTITY_PERCENTAGE]: (state, response) => {
    return (state.depbParent.quantityPercentage = response.value);
  },
  [MT.SET_DEPB_PARENT_AMENDMENT_TYPE]: (state, response) => {
    return (state.depbParent.amendmentType = response.value);
  },
  [MT.SET_DEPB_PARENT_AMENDMENT_NO]: (state, response) => {
    return (state.depbParent.amendmentNo = response.value);
  },
  [MT.SET_DEPB_PARENT_AMENDMENT_DATE]: (state, response) => {
    return (state.depbParent.amendmentDate = response.value);
  },

  //****************************************  DFIA  **********************************//
  [MT.SET_DFIA_BLANK]: state => {
    Object.keys(state.dfia).forEach(function(index) {
      state.dfia[index] = null;
    });
    return;
  },
  [MT.SET_DFIA_INVOICE_SR_NO]: (state, response) => {
    return (state.dfia.invoiceSrNo = response.value);
  },
  [MT.SET_DFIA_ITEM_SR_NO]: (state, response) => {
    return (state.dfia.itemSrNo = response.value);
  },
  [MT.SET_DFIA_SR_NO]: (state, response) => {
    return (state.dfia.srNo = response.value);
  },
  [MT.SET_DFIA_SION_GROUP_CODE]: (state, response) => {
    return (state.dfia.sionGroupCode = response.value);
  },
  [MT.SET_DFIA_SION_SR_NO]: (state, response) => {
    return (state.dfia.sionSrNo = response.value);
  },
  [MT.SET_DFIA_SION_IO_NORM_SR_NO]: (state, response) => {
    return (state.dfia.sionIoNormSrNo = response.value);
  },
  [MT.SET_DFIA_QUANTITY]: (state, response) => {
    return (state.dfia.invoiceSrNo = response.value);
  },
  [MT.SET_DFIA_UNIT_OF_MEASUREMENT]: (state, response) => {
    return (state.dfia.unitOfMeasurement = response.value);
  },
  [MT.SET_DFIA_ITEM_DESCRIPTION]: (state, response) => {
    return (state.dfia.itemDescription = response.value);
  },
  [MT.SET_DFIA_TECHNICAL_CHARACTERISTICS]: (state, response) => {
    return (state.dfia.technicalCharacteristics = response.value);
  },
  [MT.SET_DFIA_FILE_NO]: (state, response) => {
    return (state.dfia.fileNo = response.value);
  },
  [MT.SET_DFIA_LICENCE_NO]: (state, response) => {
    return (state.dfia.licenseNo = response.value);
  },
  [MT.SET_DFIA_AMENDMENT_TYPE]: (state, response) => {
    return (state.dfia.amendmentType = response.value);
  },
  [MT.SET_DFIA_AMENDMENT_NO]: (state, response) => {
    return (state.dfia.amendmentNo = response.value);
  },
  [MT.SET_DFIA_AMENDMENT_DATE]: (state, response) => {
    return (state.dfia.amendmentDate = response.value);
  },

  //*****************************************  ITEMS *******************************//

  [MT.INCREMENT_LAST_ITEM_SR_NO]: state => {
    return (state.count.lastItemNumber += 1);
  },
  [MT.SET_ITEMS_IN_EXPORT_JOB]: (state, item) => {
    const isItem = state.exportJob.items.find(
      innerItem => innerItem.invoiceSrNo === item.invoiceSrNo && innerItem.itemSrNo === item.itemSrNo
    );
    if (isItem !== undefined) {
      Object.assign(isItem, {
        ...item
      });
      return;
    } else {
      return state.exportJob.items.push(item);
    }
  },
  [MT.REMOVE_ITEM_FROM_EXPORT_JOB]: (state, item) => {
    const isItem = state.exportJob.items.findIndex(
      innerItem => innerItem.invoiceSrNo === item.invoiceSrNo && innerItem.itemSrNo === item.itemSrNo
    );
    if (isItem >= 0) {
      state.exportJob.items.splice(isItem, 1);
    }
  },
  [MT.REMOVE_ITEM_RELATED_FROM_EXPORT_JOB]: (state, item) => {
    state.exportJob.dbks = state.exportJob.dbks.filter(dbk => dbk.itemSrNo !== item.itemSrNo);
    state.exportJob.statements = state.exportJob.statements.filter(statement => statement.itemSrNo !== item.itemSrNo);
    state.exportJob.licenses = state.exportJob.licenses.filter(license => license.itemSrNo !== item.itemSrNo);
    state.exportJob.schemeAbbreviations = state.exportJob.schemeAbbreviations.filter(
      schemeAbbreviation => schemeAbbreviation.itemSrNo !== item.itemSrNo
    );
    state.exportJob.swInfoTypes = state.exportJob.swInfoTypes.filter(
      swInfoType => swInfoType.itemSrNo !== item.itemSrNo
    );
    state.exportJob.supportingDocs = state.exportJob.supportingDocs.filter(
      supportingDoc => supportingDoc.itemSrNo !== item.itemSrNo
    );
    state.exportJob.ar4s = state.exportJob.ar4s.filter(ar4 => ar4.itemSrNo !== item.itemSrNo);
    return;
  },
  [MT.REMOVE_PREVIOUS_EXIM_SCHEME_RELATED_FROM_EXPORT_JOB]: (state, eximScheme) => {
    state.exportJob.dbks = state.exportJob.dbks.filter(dbk => {
      if (dbk.itemSrNo === eximScheme.itemSrNo && dbk.invoiceSrNo === eximScheme.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.statements = state.exportJob.statements.filter(statement => {
      if (
        statement.itemSrNo === eximScheme.itemSrNo &&
        statement.invoiceSrNo === eximScheme.invoiceSrNo &&
        statement.srNo < 3
      ) {
        return false;
      } else {
        return true;
      }
    });

    state.exportJob.licenses = state.exportJob.licenses.filter(license => {
      if (license.itemSrNo === eximScheme.itemSrNo && license.invoiceSrNo === eximScheme.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
  },
  [MT.REASSIGN_ITEMSRNO_TO_ITEM_RELATED_IN_EXPORT_JOB]: (state, removingItemSrNo) => {
    // decrementing itemSrNo for GREATER THAN removing element in items array
    state.exportJob.items = state.exportJob.items.map(item => {
      if (parseInt(item.itemSrNo) > parseInt(removingItemSrNo)) {
        item.itemSrNo = parseInt(item.itemSrNo) - 1;
      }
      return item;
    });
    // decrementing itemSrNo for GREATER THAN removing element in dbks array
    state.exportJob.dbks = state.exportJob.dbks.map(dbk => {
      if (parseInt(dbk.itemSrNo) > parseInt(removingItemSrNo)) {
        dbk.itemSrNo = parseInt(dbk.itemSrNo) - 1;
      }
      return dbk;
    });
    // decrementing itemSrNo for GREATER THAN removing element in statements array
    state.exportJob.statements = state.exportJob.statements.map(statement => {
      if (parseInt(statement.itemSrNo) > parseInt(removingItemSrNo)) {
        statement.itemSrNo = parseInt(statement.itemSrNo) - 1;
      }
      return statement;
    });
    // decrementing itemSrNo for GREATER THAN removing element in licenses array
    state.exportJob.licenses = state.exportJob.licenses.map(license => {
      if (parseInt(license.itemSrNo) > parseInt(removingItemSrNo)) {
        license.itemSrNo = parseInt(license.itemSrNo) - 1;
      }
      return license;
    });
    // decrementing itemSrNo for GREATER THAN removing element in schemeAbbreviation array
    state.exportJob.schemeAbbreviations = state.exportJob.schemeAbbreviations.map(schemeAbbreviation => {
      if (parseInt(schemeAbbreviation.itemSrNo) > parseInt(removingItemSrNo)) {
        schemeAbbreviation.itemSrNo = parseInt(schemeAbbreviation.itemSrNo) - 1;
      }
      return schemeAbbreviation;
    });
    // decrementing itemSrNo for GREATER THAN removing element in swInfoTypes array
    state.exportJob.swInfoTypes = state.exportJob.swInfoTypes.map(swInfoType => {
      if (parseInt(swInfoType.itemSrNo) > parseInt(removingItemSrNo)) {
        swInfoType.itemSrNo = parseInt(swInfoType.itemSrNo) - 1;
      }
      return swInfoType;
    });
    // decrementing itemSrNo for GREATER THAN removing element in supportingDocs array
    state.exportJob.supportingDocs = state.exportJob.supportingDocs.map(supportingDoc => {
      if (parseInt(supportingDoc.itemSrNo) > parseInt(removingItemSrNo)) {
        supportingDoc.itemSrNo = parseInt(supportingDoc.itemSrNo) - 1;
      }
      return supportingDoc;
    });
    // decrementing itemSrNo for GREATER THAN removing element in ar4s array
    state.exportJob.ar4s = state.exportJob.ar4s.map(ar4 => {
      if (parseInt(ar4.itemSrNo) > parseInt(removingItemSrNo)) {
        ar4.itemSrNo = parseInt(ar4.itemSrNo) - 1;
      }
      return ar4;
    });
    return;
  },
  // Item details
  [MT.SET_ITEM]: (state, response) => {
    return (state.item = {
      ...response
    });
  },
  [MT.SET_ITEM_BLANK]: state => {
    Object.keys(state.item).forEach(function(index) {
      state.item[index] = null;
    });
    return;
  },
  [MT.SET_ITEM_ITEM_VALUE]: (state, response) => {
    return (state.item.itemValue = response.value);
  },
  [MT.SET_ITEM_INVOICE_SR_NO]: (state, response) => {
    return (state.item.invoiceSrNo = response.value);
  },
  [MT.SET_ITEM_ITEM_SR_NO]: (state, response) => {
    return (state.item.itemSrNo = response.value);
  },
  [MT.SET_ITEM_SCHEME_CODE]: (state, response) => {
    return (state.item.schemeCode = response.value);
  },
  [MT.SET_ITEM_SCHEME_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.schemeCodeDropdownValue = response.value);
  },
  [MT.SET_ITEM_RITC_CODE]: (state, response) => {
    return (state.item.ritcCode = response.value);
  },
  [MT.SET_ITEM_RITC_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.ritcCodeDropdownValue = response.value);
  },
  [MT.SET_ITEM_DESCRIPTION_OF_GOODS1]: (state, response) => {
    return (state.item.descriptionOfGoods1 = response.value);
  },
  [MT.SET_ITEM_DESCRIPTION_OF_GOODS2]: (state, response) => {
    return (state.item.descriptionOfGoods2 = response.value);
  },
  [MT.SET_ITEM_DESCRIPTION_OF_GOODS3]: (state, response) => {
    return (state.item.descriptionOfGoods3 = response.value);
  },
  [MT.SET_ITEM_UNIT_OF_MEASUREMENT_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.unitOfMeasurementDropdownValue = response.value);
  },
  [MT.SET_ITEM_UNIT_OF_MEASUREMENT]: (state, response) => {
    return (state.item.unitOfMeasurement = response.value);
  },
  [MT.SET_ITEM_QUANTITY]: (state, response) => {
    return (state.item.quantity = response.value);
  },
  [MT.SET_ITEM_RODTEP_CLAIMED]: (state, response) => {
    return (state.item.rodtepClaimed = response.value);
  },
  [MT.SET_ITEM_UNIT_PRICE]: (state, response) => {
    return (state.item.unitPrice = response.value);
  },
  [MT.SET_ITEM_UNIT_OF_RATE]: (state, response) => {
    return (state.item.unitOfRate = response.value);
  },
  [MT.SET_ITEM_UNIT_OF_RATE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.unitOfRateDropdownValue = response.value);
  },
  [MT.SET_ITEM_NO_OF_UNIT]: (state, response) => {
    return (state.item.noOfUnit = response.value);
  },
  [MT.SET_ITEM_PMV_CALULATION_PERCENTAGE]: (state, response) => {
    return (state.item.pmvCalculationPercentage = response.value);
  },
  [MT.SET_ITEM_PRESENT_MARKET_VALUE]: (state, response) => {
    return (state.item.presentMarketValue = response.value);
  },
  [MT.SET_ITEM_JOB_WORK_NOTIFICATION_NO]: (state, response) => {
    return (state.item.jobWorkNotificationNo = response.value);
  },
  [MT.SET_ITEM_IS_THIRD_PARTY]: (state, response) => {
    return (state.item.isThirdParty = response.value);
  },
  [MT.SET_ITEM_REWARD_ITEM]: (state, response) => {
    return (state.item.rewardItem = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CODE_TYPE]: (state, response) => {
    return (state.item.itemProducerCodeType = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CODE_TYPE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.itemProducerCodeTypeDropdownValue = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CODE]: (state, response) => {
    return (state.item.itemProducerCode = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.itemProducerCodeDropdownValue = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_ADDRESS1]: (state, response) => {
    return (state.item.itemProducerAddress1 = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_ADDRESS2]: (state, response) => {
    return (state.item.itemProducerAddress2 = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CITY]: (state, response) => {
    return (state.item.itemProducerCity = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_CITY_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.itemProducerCityDropdownValue = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_COUNTRY_SUB_DIVISION]: (state, response) => {
    return (state.item.itemProducerCountrySubdivision = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_PIN]: (state, response) => {
    return (state.item.itemProducerPin = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_COUNTRY_CODE]: (state, response) => {
    return (state.item.itemProducerCountryCode = response.value);
  },
  [MT.SET_ITEM_ITEM_PRODUCER_COUNTRY_CODE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.itemProducerCountryCodeDropdownValue = response.value);
  },
  [MT.SET_ITEM_SOURCE_STATE]: (state, response) => {
    return (state.item.sourceState = response.value);
  },
  [MT.SET_ITEM_SOURCE_STATE_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.sourceStateDropdownValue = response.value);
  },
  [MT.SET_ITEM_TRANSIT_COUNTRY]: (state, response) => {
    return (state.item.transitCountry = response.value);
  },
  [MT.SET_ITEM_TRANSIT_COUNTRY_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.transitCountryDropdownValue = response.value);
  },
  [MT.SET_ITEM_ACCESSORY_STATUS]: (state, response) => {
    return (state.item.accessoryStatus = response.value);
  },
  [MT.SET_ITEM_ACCESSORY_STATUS_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.accessoryStatusDropdownValue = response.value);
  },
  [MT.SET_ITEM_END_USE_OF_ITEM]: (state, response) => {
    return (state.item.endUseOfItem = response.value);
  },
  [MT.SET_ITEM_END_USE_OF_ITEM_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.endUseOfItemDropdownValue = response.value);
  },
  [MT.SET_ITEM_HAWB_NO]: (state, response) => {
    return (state.item.hawbNo = response.value);
  },
  [MT.SET_ITEM_TOTAL_PACKAGE]: (state, response) => {
    return (state.item.totalPackage = response.value);
  },
  [MT.SET_ITEM_IGST_PERCENT]: (state, response) => {
    return (state.item.igstPercent = response.value);
  },
  [MT.SET_ITEM_IGST_PAYMENT_STATUS]: (state, response) => {
    return (state.item.igstPaymentStatus = response.value);
  },
  [MT.SET_ITEM_IGST_PAYMENT_STATUS_DROPDOWN_VALUE]: (state, response) => {
    return (state.item.igstPaymentStatusDropdownValue = response.value);
  },
  [MT.SET_ITEM_TAXABLE_VALUE]: (state, response) => {
    return (state.item.taxableValue = response.value);
  },
  [MT.SET_ITEM_IGST_AMOUNT]: (state, response) => {
    return (state.item.igstAmount = response.value);
  },
  [MT.SET_ITEM_AMENDMENT_TYPE]: (state, response) => {
    return (state.item.amendmentType = response.value);
  },
  [MT.SET_ITEM_AMENDMENT_NO]: (state, response) => {
    return (state.item.amendmentNo = response.value);
  },
  [MT.SET_ITEM_AMENDMENT_DATE]: (state, response) => {
    return (state.item.amendmentDate = response.value);
  },

  //************************************  ITEMS ACCESS *******************************//
  [MT.SET_ITEM_ACCESS_BLANK]: state => {
    Object.keys(state.itemAccess).forEach(function(index) {
      state.itemAccess[index] = null;
    });
    return;
  },
  [MT.SET_ITEM_ACCESS_INVOICE_SR_NO]: (state, response) => {
    return (state.itemAccess.invoiceSrNo = response.value);
  },
  [MT.SET_ITEM_ACCESS_SR_NO]: (state, response) => {
    return (state.itemAccess.itemSrNo = response.value);
  },
  [MT.SET_ITEM_ACCESS_DESCRIPTION_ACCESSORIES]: (state, response) => {
    return (state.itemAccess.descriptionAccessories = response.value);
  },

  //******************************** ITEM RAW MATERIALS ******************************//

  [MT.SET_ITEM_RAW_MATERIALS_INVOICE_SR_NO]: (state, response) => {
    return (state.itemRawMaterial.invoiceSrNo = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_ITEM_SR_NO]: (state, response) => {
    return (state.itemRawMaterial.itemSrNo = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_RAW_MATERIAL_CODE]: (state, response) => {
    return (state.itemRawMaterial.rawMaterialCode = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_QUANTITY]: (state, response) => {
    return (state.itemRawMaterial.quantity = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_AMENDMENT_TYPE]: (state, response) => {
    return (state.itemRawMaterial.amendmentType = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_AMENDMENT_NO]: (state, response) => {
    return (state.itemRawMaterial.amendmentNo = response.value);
  },
  [MT.SET_ITEM_RAW_MATERIALS_AMENDMENT_DATE]: (state, response) => {
    return (state.itemRawMaterial.amendmentDate = response.value);
  },

  //*********************************** JOB WORK  ********************************//

  [MT.SET_JOB_WORK_INVOICE_SR_NO]: (state, response) => {
    return (state.jobwork.invoiceSrNo = response.value);
  },
  [MT.SET_JOB_WORK_ITEM_SR_NO]: (state, response) => {
    return (state.jobwork.itemSrNo = response.value);
  },
  [MT.SET_JOB_WORK_SR_NO]: (state, response) => {
    return (state.jobwork.srNo = response.value);
  },
  [MT.SET_JOB_WORK_BE_NO]: (state, response) => {
    return (state.jobwork.beNo = response.value);
  },
  [MT.SET_JOB_WORK_BE_DATE]: (state, response) => {
    return (state.jobwork.beDate = response.value);
  },
  [MT.SET_JOB_WORK_BE_INVOICE_SR_NO]: (state, response) => {
    return (state.jobwork.beInvoiceSrNo = response.value);
  },
  [MT.SET_JOB_WORK_BE_INVOICE_NO]: (state, response) => {
    return (state.jobwork.beInvoiceNo = response.value);
  },
  [MT.SET_JOB_WORK_BE_ITEM_NO]: (state, response) => {
    return (state.jobwork.beItemNo = response.value);
  },
  [MT.SET_JOB_WORK_BE_PORT_CODE]: (state, response) => {
    return (state.jobwork.bePortCode = response.value);
  },
  [MT.SET_JOB_WORK_BE_QUANTITY_USED]: (state, response) => {
    return (state.jobwork.beQtyUsed = response.value);
  },
  [MT.SET_JOB_WORK_QUANTITY_UNITS]: (state, response) => {
    return (state.jobwork.QtyUnits = response.value);
  },
  [MT.SET_JOB_WORK_AMENDMENT_TYPE]: (state, response) => {
    return (state.jobwork.amendmentType = response.value);
  },
  [MT.SET_JOB_WORK_AMENDMENT_NO]: (state, response) => {
    return (state.jobwork.amendmentNo = response.value);
  },
  [MT.SET_JOB_WORK_AMENDMENT_DATE]: (state, response) => {
    return (state.jobwork.amendmentDate = response.value);
  },
  //*********************************** PACKING LIST  ********************************//
  [MT.SET_PACKING_LIST_BLANK]: state => {
    Object.keys(state.packingList).forEach(function(index) {
      state.packingList[index] = null;
    });
    return;
  },
  [MT.SET_PACKING_LIST_FROM_EXPORT_JOB]: (state, response) => {
    return (state.packingList = {
      ...response
    });
    // if (state.exportJob.packingLists.length > 0) {
    //   state.packingList = { ...state.exportJob.packingLists[0] };
    // }
    // return;
  },
  [MT.SET_PACKING_LIST_IN_EXPORT_JOB]: (state, packingList) => {
    state.exportJob.packingLists.splice(0, state.exportJob.packingLists.length);
    state.exportJob.packingLists.push(packingList);
    return;
  },
  [MT.SET_PACKING_LIST_PACKING_NO_FROM]: (state, response) => {
    return (state.packingList.packingNoFrom = response.value);
  },
  [MT.SET_PACKING_LIST_PACKING_NO_TO]: (state, response) => {
    return (state.packingList.packingNoTo = response.value);
  },
  [MT.SET_PACKING_LIST_PACKING_CODE]: (state, response) => {
    return (state.packingList.packingCode = response.value);
  },

  //*********************************** ROTATION  ********************************//

  [MT.SET_ROTATION_ROTATION_NO]: (state, response) => {
    return (state.rotation.rotationNo = response.value);
  },
  [MT.SET_ROTATION_ROTATION_DATE]: (state, response) => {
    return (state.rotation.rotationDate = response.value);
  },
  //*********************************** STATEMENT  ********************************//
  [MT.SET_STATEMENT_BLANK]: state => {
    Object.keys(state.statement).forEach(function(index) {
      state.statement[index] = null;
    });
    return;
  },
  [MT.SET_STATEMENT_IN_EXPORT_JOB]: (state, statement) => {
    // if drawback exists
    const isStatement = state.exportJob.statements.find(
      innerStatement =>
        innerStatement.invoiceSrNo === statement.invoiceSrNo &&
        innerStatement.itemSrNo === statement.itemSrNo &&
        innerStatement.srNo === statement.srNo
    );
    if (isStatement !== undefined) {
      Object.assign(isStatement, {
        ...statement
      });
      return;
    } else {
      return state.exportJob.statements.push(statement);
    }
  },
  [MT.REMOVE_RODTEP_STATEMENT_IN_EXPORT_JOB]: (state, rodtepStatement) => {
    // if drawback exists
    state.exportJob.statements = state.exportJob.statements.filter(statement => {
      if (statement.srNo === rodtepStatement.srNo && statement.itemSrNo === rodtepStatement.itemSrNo) {
        return false;
      } else {
        return true;
      }
    });
  },
  [MT.SET_STATEMENT_INVOICE_SR_NO]: (state, response) => {
    return (state.statement.invoiceSrNo = response.value);
  },
  [MT.SET_STATEMENT_ITEM_SR_NO]: (state, response) => {
    return (state.statement.itemSrNo = response.value);
  },
  [MT.SET_STATEMENT_SR_NO]: (state, response) => {
    return (state.statement.srNo = response.value);
  },
  [MT.SET_STATEMENT_STATEMENT_TYPE]: (state, response) => {
    return (state.statement.statementType = response.value);
  },
  [MT.SET_STATEMENT_STATEMENT_CODE]: (state, response) => {
    return (state.statement.statementCode = response.value);
  },
  [MT.SET_STATEMENT_STATEMENT_TEXT_FLAT_FILE]: (state, response) => {
    return (state.statement.statementTextFlatFile = response.value);
  },
  [MT.SET_STATEMENT_STATEMENT_TEXT]: (state, response) => {
    return (state.statement.statementText = response.value);
  },

  //*********************************** STUFF  ***************************************//

  [MT.SET_STUFF_GOODS_STUFFED_AT]: (state, response) => {
    return (state.stuff.factoryStuffed = response.value);
  },
  [MT.SET_STUFF_SAMPLE_ACCOMPANIED]: (state, response) => {
    return (state.stuff.sampleAccompanied = response.value);
  },

  //*********************************  SUPPORTING DOCS  ******************************//
  [MT.SET_SUPPORTING_DOC_BLANK]: state => {
    Object.keys(state.supportingDoc).forEach(function(index) {
      state.supportingDoc[index] = null;
    });
    return;
  },
  [MT.ATTACH_SUPPORTING_DOC_IN_EXPORT_JOB]: (state, supportingDoc) => {
    var supportingDocSrNo = supportingDoc.srNo;
    if (supportingDocSrNo > state.exportJob.supportingDocs.length) {
      return state.exportJob.supportingDocs.push(supportingDoc);
    } else if (supportingDocSrNo > 0) {
      supportingDocSrNo = supportingDocSrNo - 1;
      const existingSupportingDoc = state.exportJob.supportingDocs[supportingDocSrNo];
      Object.assign(existingSupportingDoc, {
        ...supportingDoc
      });
      return;
    }
  },
  [MT.DELETE_SUPPORTING_DOC_FROM_EXPORT_JOB]: (state, supportingDoc) => {
    var supportingDocSrNo = supportingDoc.srNo;
    const supportingDocIndex = state.exportJob.supportingDocs.findIndex(
      supportingDoc => supportingDoc.srNo === supportingDocSrNo
    );
    if (supportingDocIndex >= 0) {
      state.exportJob.supportingDocs.splice(supportingDocIndex, 1);
    }
    return;
  },

  [MT.REASSIGN_SRNO_TO_SUPPORTING_DOCS_IN_EXPORT_JOB]: (state, response) => {
    // decrementing srNo for GREATER THAN removing element in supportingDocs array
    const removingSrNo = response.srNo;
    state.exportJob.supportingDocs = state.exportJob.supportingDocs.map(supportingDoc => {
      if (parseInt(supportingDoc.srNo) > parseInt(removingSrNo)) {
        supportingDoc.srNo = parseInt(supportingDoc.srNo) - 1;
      }
      return supportingDoc;
    });
  },
  [MT.SET_SUPPORTING_DOC_INVOICE_SR_NO]: (state, response) => {
    return (state.supportingDoc.invoiceSrNo = response.value);
  },
  [MT.SET_SUPPORTING_DOC_ITEM_SR_NO]: (state, response) => {
    return (state.supportingDoc.itemSrNo = response.value);
  },
  [MT.SET_SUPPORTING_DOC_SR_NO]: (state, response) => {
    return (state.supportingDoc.srNo = response.value);
  },
  [MT.SET_SUPPORTING_DOC_IMG_REFERENCE_NO]: (state, response) => {
    return (state.supportingDoc.imgReferenceNo = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_TYPE_CODE]: (state, response) => {
    return (state.supportingDoc.documentTypeCode = response.value);
  },
  [MT.SET_SUPPORTING_DOC_ICEGATE_FILE_NAME]: (state, response) => {
    return (state.supportingDoc.icegateFileName = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_LEVEL_TITLE]: (state, response) => {
    return (state.supportingDoc.documentLevelTitle = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_CODE]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyCode = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME_ADDRESS1]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyNameAddress1 = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME_ADDRESS2]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyNameAddress2 = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME_CITY]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyNameCity = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyName = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUING_PARTY_NAME_PIN]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyNamePin = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_REFERENCE_NO]: (state, response) => {
    return (state.supportingDoc.documentReferenceNo = response.value);
  },
  [MT.SET_SUPPORTING_DOC_PLACE_OF_ISSUE]: (state, response) => {
    return (state.supportingDoc.placeOfIssue = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_ISSUE_DATE]: (state, response) => {
    return (state.supportingDoc.documentIssueDate = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_EXPIRY_DATE]: (state, response) => {
    return (state.supportingDoc.documentExpiryDate = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_CODE]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyCode = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_NAME_ADDRESS1]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyNameAddress1 = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_NAME_ADDRESS2]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyNameAddress2 = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_NAME_CITY]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyNameCity = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_NAME_PIN]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyNamePin = response.value);
  },
  [MT.SET_SUPPORTING_DOC_FILE_TYPE]: (state, response) => {
    return (state.supportingDoc.fileType = response.value);
  },
  [MT.SET_SUPPORTING_DOC_ISSUE_PARTY_NAME]: (state, response) => {
    return (state.supportingDoc.documentIssuingPartyName = response.value);
  },
  [MT.SET_SUPPORTING_DOC_DOCUMENT_BENEFECIARY_PARTY_NAME]: (state, response) => {
    return (state.supportingDoc.documentBeneficiaryPartyName = response.value);
  },
  [MT.SET_SUPPORTING_DOC_ICEGATE_ID]: (state, response) => {
    return (state.supportingDoc.icegateId = response.value);
  },

  //*********************************  SWCONST  **********************************//

  [MT.SET_SW_CONST_INVOICE_SR_NO]: (state, response) => {
    return (state.swConst.invoiceSrNo = response.value);
  },
  [MT.SET_SW_CONST_ITEM_SR_NO]: (state, response) => {
    return (state.swConst.itemSrNo = response.value);
  },
  [MT.SET_SW_CONST_SR_NO]: (state, response) => {
    return (state.swConst.srNo = response.value);
  },
  [MT.SET_SW_CONST_CONSTITUENT_ELEMENT_NAME]: (state, response) => {
    return (state.swConst.constituentElementName = response.value);
  },
  [MT.SET_SW_CONST_CONSTITUENT_CODE]: (state, response) => {
    return (state.swConst.constituentCode = response.value);
  },
  [MT.SET_SW_CONST_CONSTITUENT_PERCENTAGE]: (state, response) => {
    return (state.swConst.constituentPercentage = response.value);
  },
  [MT.SET_SW_CONST_CONSTITUENT_YIELD_PERCENTAGE]: (state, response) => {
    return (state.swConst.constituentYieldPercentage = response.value);
  },
  [MT.SET_SW_CONST_ACTIVE_INGREDIENT]: (state, response) => {
    return (state.swConst.activeIngredient = response.value);
  },

  //*********************************  SWCTRL  **********************************//

  [MT.SET_SW_CTRL_INVOICE_SR_NO]: (state, response) => {
    return (state.swCtrl.invoiceSrNo = response.value);
  },
  [MT.SET_SW_CTRL_ITEM_SR_NO]: (state, response) => {
    return (state.swCtrl.itemSrNo = response.value);
  },
  [MT.SET_SW_CTRL_SR_NO]: (state, response) => {
    return (state.swCtrl.srNo = response.value);
  },
  [MT.SET_SW_CTRL_CONTROL_TYPE_CODE]: (state, response) => {
    return (state.swCtrl.controlTypeCode = response.value);
  },
  [MT.SET_SW_CTRL_CONTROL_LOCATION]: (state, response) => {
    return (state.swCtrl.controlLocation = response.value);
  },
  [MT.SET_SW_CTRL_CONTROL_START_DATE]: (state, response) => {
    return (state.swCtrl.controlStartDate = response.value);
  },
  [MT.SET_SW_CTRL_CONTROL_END_DATE]: (state, response) => {
    return (state.swCtrl.controlEndDate = response.value);
  },
  [MT.SET_SW_CTRL_RESULT_CODE]: (state, response) => {
    return (state.swCtrl.controlResultCode = response.value);
  },
  [MT.SET_SW_CTRL_RESULT_REMARKS]: (state, response) => {
    return (state.swCtrl.controlResultRemarks = response.value);
  },

  //*********************************  SW INFO TYPES  ********************************//

  [MT.REMOVE_SW_INFO_TYPE_FROM_EXPORT_JOB_FOR_RELATED_ITEMS]: (state, swInfoType) => {
    state.exportJob.swInfoTypes = state.exportJob.swInfoTypes.filter(swInfo => {
      if (swInfo.itemSrNo === swInfoType.itemSrNo && swInfo.invoiceSrNo === swInfoType.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    return;
  },
  [MT.SET_SW_INFO_TYPE_BLANK]: state => {
    Object.keys(state.swInfoType).forEach(function(index) {
      state.swInfoType[index] = null;
    });
    return;
  },
  [MT.SET_SW_INFO_TYPE_IN_EXPORT_JOB]: (state, swInfoType) => {
    return state.exportJob.swInfoTypes.push(swInfoType);
  },
  [MT.SORT_SW_INFO_TYPE_IN_EXPORT_JOB]: state => {
    state.exportJob.swInfoTypes = state.exportJob.swInfoTypes.sort((a, b) => {
      if (a.invoiceSrNo === b.invoiceSrNo) {
        if (a.itemSrNo === b.itemSrNo) return a.srNo - b.srNo;
      }
    });
  },
  [MT.SET_SW_INFO_TYPE_INVOICE_SR_NO]: (state, response) => {
    return (state.swInfoType.invoiceSrNo = response.value);
  },
  [MT.SET_SW_INFO_TYPE_ITEM_SR_NO]: (state, response) => {
    return (state.swInfoType.itemSrNo = response.value);
  },
  [MT.SET_SW_INFO_TYPE_SR_NO]: (state, response) => {
    return (state.swInfoType.srNo = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_TYPE]: (state, response) => {
    return (state.swInfoType.infoType = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_QUALIFIER]: (state, response) => {
    return (state.swInfoType.infoQualifier = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_CODE]: (state, response) => {
    return (state.swInfoType.infoCode = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_TEXT]: (state, response) => {
    return (state.swInfoType.infoText = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_MSR]: (state, response) => {
    return (state.swInfoType.infoMsr = response.value);
  },
  [MT.SET_SW_INFO_TYPE_INFO_UQC]: (state, response) => {
    return (state.swInfoType.infoUqc = response.value);
  },

  //*********************************  SWPROD  **********************************//

  [MT.SET_SW_PROD_INVOICE_SR_NO]: (state, response) => {
    return (state.swProd.invoiceSrNo = response.value);
  },
  [MT.SET_SW_PROD_ITEM_SR_NO]: (state, response) => {
    return (state.swProd.itemSrNo = response.value);
  },
  [MT.SET_SW_PROD_SR_NO]: (state, response) => {
    return (state.swProd.srNo = response.value);
  },
  [MT.SET_SW_PROD_PRODUCTION_BATCH_IDENTIFIER]: (state, response) => {
    return (state.swProd.productionBatchIdentifier = response.value);
  },
  [MT.SET_SW_PROD_PRODUCTION_BATCH_QUANTITY]: (state, response) => {
    return (state.swProd.productionBatchQuantity = response.value);
  },
  [MT.SET_SW_PROD_INFO_QUALIFIER]: (state, response) => {
    return (state.swProd.infoQualifier = response.value);
  },
  [MT.SET_SW_PROD_UNIT_QUALITY_CODE]: (state, response) => {
    return (state.swProd.unitQuatityCode = response.value);
  },
  [MT.SET_SW_PROD_DATE_OF_MANUFACTURING]: (state, response) => {
    return (state.swProd.dateOfManufacturing = response.value);
  },
  [MT.SET_SW_PROD_DATE_OF_EXPIRY]: (state, response) => {
    return (state.swProd.dateOfExpiry = response.value);
  },
  [MT.SET_SW_PROD_BEST_BEFORE]: (state, response) => {
    return (state.swProd.bestBefore = response.value);
  },

  //*********************************  THIRD PARTY  **********************************//
  [MT.SET_THIRD_PARTY_BLANK]: state => {
    Object.keys(state.thirdParty).forEach(function(index) {
      state.thirdParty[index] = null;
    });
    return;
  },
  [MT.SET_THIRD_PARTY_INVOICE_SR_NO]: (state, response) => {
    return (state.thirdParty.invoiceSrNo = response.value);
  },
  [MT.SET_THIRD_PARTY_ITEM_SR_NO]: (state, response) => {
    return (state.thirdParty.itemSrNo = response.value);
  },
  [MT.SET_THIRD_PARTY_IEC]: (state, response) => {
    return (state.thirdParty.iec = response.value);
  },
  [MT.SET_THIRDPARTY_BRANCH_SR_NO]: (state, response) => {
    return (state.thirdParty.branchSrNo = response.value);
  },
  [MT.SET_THIRDPARTY_EXPORTER_NAME]: (state, response) => {
    return (state.thirdParty.exporterName = response.value);
  },
  [MT.SET_THIRDPARTY_EXPORTER_ADDRESS1]: (state, response) => {
    return (state.thirdParty.exporterAddress1 = response.value);
  },
  [MT.SET_THIRDPARTY_EXPORTER_ADDRESS2]: (state, response) => {
    return (state.thirdParty.exporterAddress2 = response.value);
  },
  [MT.SET_THIRDPARTY_CITY]: (state, response) => {
    return (state.thirdParty.city = response.value);
  },
  [MT.SET_THIRDPARTY_PIN]: (state, response) => {
    return (state.thirdParty.pin = response.value);
  },
  [MT.SET_THIRDPARTY_AMENDMENT_TYPE]: (state, response) => {
    return (state.thirdParty.amendmentType = response.value);
  },
  [MT.SET_THIRDPARTY_AMENDMENT_NO]: (state, response) => {
    return (state.thirdParty.amendmentNo = response.value);
  },
  [MT.SET_THIRDPARTY_AMENDMENT_TYPE]: (state, response) => {
    return (state.thirdParty.amendmentDate = response.value);
  },
  [MT.SET_THIRDPARTY_GSTN_TYPE]: (state, response) => {
    return (state.thirdParty.gstnType = response.value);
  },
  [MT.SET_THIRDPARTY_GSTN_ID]: (state, response) => {
    return (state.thirdParty.gstnId = response.value);
  },

  // Invoice Details
  [MT.SET_INVOICES_IN_EXPORT_JOB]: (state, response) => {
    var invoiceSrNo = response.invoiceSrNo;
    if (invoiceSrNo > state.exportJob.invoices.length) {
      return state.exportJob.invoices.push(response);
    } else if (invoiceSrNo > 0) {
      invoiceSrNo = invoiceSrNo - 1;
      const invoice = state.exportJob.invoices[invoiceSrNo];
      Object.assign(invoice, {
        ...response
      });
      return;
    }
  },
  [MT.REASSIGN_SRNO_TO_INVOICE_EXPORT_JOB]: (state, removingSrNo) => {
    // decrementing srNo for GREATER THAN removing element in invoices array
    state.exportJob.invoices = state.exportJob.invoices.map(invoice => {
      if (parseInt(invoice.invoiceSrNo) > parseInt(removingSrNo)) {
        invoice.invoiceSrNo = parseInt(invoice.invoiceSrNo) - 1;
      }
      return invoice;
    });
  },
  [MT.REMOVE_INVOICE_FROM_EXPORT_JOB]: (state, response) => {
    const invoiceSrNo = response.srNo;
    const invoiceIndex = state.exportJob.invoices.findIndex(invoice => invoice.invoiceSrNo === invoiceSrNo);
    if (invoiceIndex >= 0) {
      state.exportJob.invoices.splice(invoiceIndex, 1);
    }
    return;
  },
  [MT.REMOVE_INVOICE_RELATED_FROM_EXPORT_JOB]: (state, invoice) => {
    state.exportJob.dbks = state.exportJob.dbks.filter(dbk => {
      if (dbk.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.statements = state.exportJob.statements.filter(statement => {
      if (statement.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.licenses = state.exportJob.licenses.filter(license => {
      if (license.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.items = state.exportJob.items.filter(item => {
      if (item.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.swInfoTypes = state.exportJob.swInfoTypes.filter(swInfoType => {
      if (swInfoType.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.supportingDocs = state.exportJob.supportingDocs.filter(supportingDoc => {
      if (supportingDoc.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
    state.exportJob.ar4s = state.exportJob.ar4s.filter(ar4 => {
      if (ar4.invoiceSrNo === invoice.invoiceSrNo) {
        return false;
      } else {
        return true;
      }
    });
  },
  [MT.INCREMENT_LAST_INVOICE_SR_NO]: state => {
    return (state.count.lastInvoiceNumber += 1);
  },

  [MT.SET_INVOICE]: (state, response) => {
    return (state.invoice = {
      ...response
    });
  },
  [MT.SET_EXPORTER_NAME]: (state, response) => {
    return (state.exportJob.exporterName = response.value);
  },
  [MT.SET_EXPORTER_IEC]: (state, response) => {
    return (state.exportJob.iec = response.value);
  },
  [MT.SET_EXPORT_JOB_BLANK]: state => {
    Object.keys(state.exportJob).forEach(function(index) {
      if (Array.isArray(state.exportJob[index])) {
        state.exportJob[index] = [];
      } else {
        state.exportJob[index] = {};
      }
      return;
    });
    return;
  },
  [MT.SET_EXPORT_JOB]: (state, response) => {
    state.exportJob = response.exportJob;
    state.sbMain = response.exportJob.sbMain;
    return;
  },
  [MT.SET_EXPORT_JOB_ID]: (state, response) => {
    state.exportJobId = response.id;
    return;
  },
  [MT.SET_INVOICE_PRODUCTS_PAGE_PASSED]: state => {
    state.isInvoiceProductsPagePassed = true;
    return;
  },
  [MT.SET_SCHEME_ABBREVIATION_IN_EXPORT_JOB]: (state, response) => {
    state.exportJob.schemeAbbreviations = state.exportJob.schemeAbbreviations.flat(3).filter(schemeAbbreviation => {
      if (
        schemeAbbreviation.itemSrNo === response.itemSrNo &&
        schemeAbbreviation.invoiceSrNo === response.invoiceSrNo
      ) {
        return false;
      } else {
        return true;
      }
    });
    return state.exportJob.schemeAbbreviations.push(...response.schemeAbbreviation);
  },

  [MT.SET_SCHEME_ABBREVIATION_BLANK]: state => {
    state.schemeAbbreviations.splice(0, state.schemeAbbreviations.length);
    // Object.keys(state.schemeAbbreviation).forEach(function(index) {
    //   state.schemeAbbreviation[index] = null;
  },

  [MT.RE_COMPUTE_FOB_RELATED_ELEMENTS]: state => {
    state.exportJob.items.map(item => {
      const invoice = state.exportJob.invoices.find(invoice => invoice.invoiceSrNo === item.invoiceSrNo);
      if (invoice !== undefined) {
        const invoiceValue = invoice.invoiceValue !== null ? parseFloat(invoice.invoiceValue) : 0;
        const exchangeRate = invoice.exchangeRate !== null ? parseFloat(invoice.exchangeRate) : 1;
        const freight = invoice.freightAmount !== null ? parseFloat(invoice.freightAmount) : 0;
        const insurance = invoice.insuranceAmount !== null ? parseFloat(invoice.insuranceAmount) : 0;
        const discount = invoice.discountAmount !== null ? parseFloat(invoice.discountAmount) : 0;
        const commission = invoice.commissionAmount !== null ? parseFloat(invoice.commissionAmount) : 0;
        const invoiceFob = invoiceValue - freight - insurance - discount - commission;
        // const itemValue = item.itemValue !== null ? parseFloat(item.itemValue) : 0;
        const itemUnitPrice = parseFloat(item.unitPrice);

        if (invoiceValue != 0) {
          const itemUnitPriceFobInr = ((itemUnitPrice * invoiceFob) / invoiceValue) * exchangeRate;
          const pmvPerUnit = parseFloat(itemUnitPriceFobInr * (parseInt(item.pmvCalculationPercentage) / 100));
          item.presentMarketValue = pmvPerUnit.toFixed(2);
        }
      }
      return item;
    });

    state.exportJob.dbks.map(dbk => {
      const invoice = state.exportJob.invoices.find(invoice => invoice.invoiceSrNo === dbk.invoiceSrNo);
      const item = state.exportJob.items.find(
        item => item.itemSrNo === dbk.itemSrNo && item.invoiceSrNo === dbk.invoiceSrNo
      );
      if (invoice !== undefined && item !== undefined) {
        const invoiceValue = invoice.invoiceValue !== null ? parseFloat(invoice.invoiceValue) : 0;
        const exchangeRate = invoice.exchangeRate !== null ? parseFloat(invoice.exchangeRate) : 1;
        const freight = invoice.freightAmount !== null ? parseFloat(invoice.freightAmount) : 0;
        const insurance = invoice.insuranceAmount !== null ? parseFloat(invoice.insuranceAmount) : 0;
        const discount = invoice.discountAmount !== null ? parseFloat(invoice.discountAmount) : 0;
        const itemValue = item.itemValue !== null ? parseFloat(item.itemValue) : 0;
        const invoiceFob = invoiceValue - freight - insurance - discount;

        // divide by zero check
        if (invoiceValue != 0) {
          // cross multiplication
          // invoiceValue <-> invoiceFob
          // itemValue <-> ?
          const itemFobInr = ((itemValue * invoiceFob) / invoiceValue) * exchangeRate;

          const dbkRate = parseFloat(dbk.dbkRate);
          const dbkAmount = ((itemFobInr * dbkRate) / 100).toFixed(2);
          dbk.dbkAmount = dbkAmount;
        }
      }
      return dbk;
    });
    return;
  }
};
